import{styled as r}from"@mui/material/styles";import e from"@mui/material/Divider";const m=r(e)((({theme:r})=>({borderColor:r.palette.grey200.main})));export{m as MUIDivider};
//# sourceMappingURL=styles.js.map
